import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
    UserSwitchOutlined,
    TransactionOutlined,
    BankOutlined,
    BarChartOutlined,
    DatabaseOutlined,
    DeploymentUnitOutlined,
    DownOutlined,
    UserDeleteOutlined,
    BookOutlined,
    SettingOutlined,
    NotificationOutlined,
    ProductOutlined,
    QrcodeOutlined,
    RobotOutlined,
    LoadingOutlined,
    ShareAltOutlined
} from '@ant-design/icons';
import { Layout, Menu, Button, theme, Dropdown, Space, Flex, Avatar, Segmented, Spin } from 'antd';

import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom"
import { connect } from "react-redux"
import { LocalStorageService } from '../services/LocalStorage';
import { isLogin, setUserData } from '../actions';
import Notification from './Notification';
import useCustomer from '../hooks/useCustomer';
import AxiosService from '../services/APIService';
import webSocketService from '../services/websocketService';
import logo from "../assets/sidebarLogo.png"
import logoSm from "../assets/sidebarLogoSm.png"
import {getLoginRoute} from '../utils/commonFunc';
import { CodeArtifact, CodePipeline } from 'aws-sdk';
const { Header, Sider, Content } = Layout;

// Static styles
const sidebarStyle = {
    background: '#131c2b',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    zIndex: 100,
    transition: 'width 0.3s ease-in-out'
};
const headerStyle = (collapsed) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 101,
    padding: '0PX 20PX',
    marginLeft: collapsed ? 80 : 230,
    background: '#131c2b',
    lineHeight: '63px'
});
const contentStyle = (borderRadiusLG) => ({
    margin: '24px 16px',
    padding: 24,
    background: 'rgb(220 220 220 / 52%)',
    borderRadius: borderRadiusLG,
    overflow: 'auto'
});

const horizontalMenuItem = [
    { value: '1', label: 'Contract Base' },
    { value: '2', label: 'White Label' },
    { value: '3', label: 'Pip Grid' },
    { value: '4', label: 'Make My Profit' },
];

const dropdownItems = [
    { label: 'Logout', key: '0' },
    { label: 'Download Database', key: '1' },
];

const AdminLayout = ({ children, user,customer, isLogin, setUserData, currentRoute }) => {
    const [currentActive, setCurrentActive] = useState('1')
    const apiService = useMemo(() => new AxiosService(), [])
    const [collapsed, setCollapsed] = useState(false);
    const [headerMenu, setHeaderMenu] = useState('1');
    const [loading, setLoading] = useState(false);
    const [userCount, setUserCount] = useState({
        pendingUser: 0,
        user: 0,
        closeUser: 0,
        editReq: 0,
        settingReq: 0,
        wlList: 0,
        wlPending: 0,
        wlClosed: 0
    });
    const navigate = useNavigate()
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    // Memoized menu items
    const adminMenuItems = useMemo(() => [
        { key: '/home', icon: <ProductOutlined />, label: <Link to={'/home'}>Dashboard</Link> },
        { key: '/users', icon: <UserOutlined />, label: <Link to={'/users'}>Users ({userCount.user})</Link> },
        { key: '/pending-users', icon: <UserSwitchOutlined />, label: <Link to={'/pending-users'}>Pending Users ({userCount.pendingUser})</Link> },
        { key: '/close-user', icon: <UserDeleteOutlined />, label: <Link to={'/close-user'}>Closed Users ({userCount.closeUser})</Link> },
        {
            key: 'transaction',
            icon: <TransactionOutlined />, label: 'Transaction',
            children: [
                { key: '/deposit-report', label: <Link to={'/deposit-report'}>Deposit Report</Link> },
                { key: '/withdraw-report', label: <Link to={'/withdraw-report'}>Withdraw Report</Link> },
                { key: '/botcharge-report', label: <Link to={'/botcharge-report'}>Bot Charge</Link> },
            ],
        },
        { key: '/profit', icon: <BarChartOutlined />, label: <Link to={'/profit'}>Profit</Link> },
        { key: '/broker', icon: <BankOutlined />, label: <Link to={'/broker'}>Brokers</Link> },
        { key: '/server', icon: <DatabaseOutlined />, label: <Link to={'/server'}>VPS Server</Link> },
        user?.role === 'ADMIN' && { key: '/team', icon: <DeploymentUnitOutlined />, label: <Link to={'/team'}>Sub Admin</Link> },
        {
            key: 'service-request',
            icon: <SettingOutlined />,
            label: `Service Request (${userCount.editReq + userCount.settingReq})`,
            children: [
                { key: '/note-request', label: <Link to={'/note-request'}>Note Request ({userCount.editReq})</Link> },
                { key: '/setting-request', label: <Link to={'/setting-request'}>Setting Request ({userCount.settingReq})</Link> },
            ],
        },
        { key: '/bot-file', icon: <BookOutlined />, label: <Link to={'/bot-file'}>Bot File</Link> },
        { key: '/announcement', icon: <NotificationOutlined />, label: <Link to={'/announcement'}>Announcement</Link> },
        { key: '/qr-code', icon: <QrcodeOutlined />, label: <Link to={'/qr-code'}>QR Code</Link> },
        { key: '/bot-performance', icon: <RobotOutlined />, label: <Link to={'/bot-performance'}>Bot Performance</Link> },
    ].filter(Boolean), [userCount, user]);

    const whiteLabelMenuItems = useMemo(() => [
        { key: '/white-label/home', icon: <ProductOutlined />, label: <Link to={'/white-label/home'}>Dashboard</Link> },
        {
            key: 'white-label',
            icon: <UserOutlined />,
            label: `White Label (${userCount.wlList + userCount.wlPending + userCount.wlClosed})`,
            children: [
                { key: '/white-label/list', label: <Link to={'/white-label/list'}>List ({userCount.wlList})</Link> },
                { key: '/white-label/pending', label: <Link to={'/white-label/pending'}>Pending ({userCount.wlPending})</Link> },
                { key: '/white-label/close', label: <Link to={'/white-label/close'}>Closed ({userCount.wlClosed})</Link> },
            ],
        },
        {
            key: 'white-label-users',
            icon: <UserOutlined />,
            label: 'Users',
            children: [
                { key: '/white-label/user-list', label: <Link to={'/white-label/user-list'}>List</Link> },
                { key: '/white-label/pending-user', label: <Link to={'/white-label/pending-user'}>Pending</Link> },
                { key: '/white-label/reject-user', label: <Link to={'/white-label/reject-user'}>Rejected</Link> },
                { key: '/white-label/close-user', label: <Link to={'/white-label/close-user'}>Closed</Link> },
            ],
        },
        {
            key: 'white-label-transaction',
            icon: <TransactionOutlined />, label: 'Transaction',
            children: [
                { key: '/white-label/deposit-report', label: <Link to={'/white-label/deposit-report'}>Deposit Report</Link> },
                { key: '/white-label/withdraw-report', label: <Link to={'/white-label/withdraw-report'}>Withdraw Report</Link> },
                { key: '/white-label/botcharge-report', label: <Link to={'/white-label/botcharge-report'}>Bot Charge</Link> },
            ],
        },
        { key: '/white-label/bill-report', icon: <BookOutlined />, label: <Link to={'/white-label/bill-report'}>Bill Report</Link> },
        { key: '/white-label/profit', icon: <BarChartOutlined />, label: <Link to={'/white-label/profit'}>Profit</Link> },
        { key: '/white-label/broker', icon: <BankOutlined />, label: <Link to={'/white-label/broker'}>Broker</Link> },
        { key: '/white-label/server', icon: <DatabaseOutlined />, label: <Link to={'/white-label/server'}>VPS Server</Link> },
        { key: '/white-label/bot-file', icon: <BookOutlined />, label: <Link to={'/white-label/bot-file'}>Bot File</Link> },
        { key: '/white-label/announcement', icon: <NotificationOutlined />, label: <Link to={'/white-label/announcement'}>Announcement</Link> },
        { key: '/white-label/qr-code', icon: <QrcodeOutlined />, label: <Link to={'/white-label/qr-code'}>QR Code</Link> },
        { key: '/white-label/level', icon: <QrcodeOutlined />, label: <Link to={'/white-label/level'}>Level</Link> },
        { key: '/white-label/leads-inquiry', icon: <ShareAltOutlined />, label: <Link to={'/white-label/leads-inquiry'}>Inquiry</Link> },
        { key: '/white-label/exhibition', icon: <ShareAltOutlined />, label: <Link to={'/white-label/exhibition'}>Exhibition</Link> },
    ], [userCount]);

    const PipadminMenuItems = useMemo(() => [
        { key: '/pip-Grid/home', icon: <ProductOutlined />, label: <Link to={'/pip-Grid/home'}>Dashboard</Link> },
        {
            key: 'pip-users',
            icon: <UserOutlined />,
            label: 'List Of Users',
            children: [
                { key: '/pip-Grid/users-request', label: <Link to={'/pip-Grid/users-request'}>Request</Link> },
                { key: '/pip-Grid/users-list', label: <Link to={'/pip-Grid/users-list'}>List</Link> },
            ],
        },
        { key: '/pip-Grid/leads-list', icon: <BookOutlined />, label: <Link to={'/pip-Grid/leads-list'}>Leads</Link> },
        { key: '/pip-Grid/notes', icon: <BookOutlined />, label: <Link to={'/pip-Grid/notes'}>Notes</Link> },
        { key: '/pip-Grid/promo-code', icon: <QrcodeOutlined/>, label: <Link to={'/pip-Grid/promo-code'}>Promo Code</Link> },
        {
            key: 'pip-affiliate',
            icon: <ShareAltOutlined />,
            label: 'Affiliate',
            children: [
                { key: '/pip-Grid/affiliate-request', label: <Link to={'/pip-Grid/affiliate-request'}>Affiliate Request</Link> },
                { key: '/pip-Grid/affiliate-users', label: <Link to={'/pip-Grid/affiliate-users'}>Affiliate Users</Link> },
            ],
        },
        {
            key: 'pip-payout',
            icon: <TransactionOutlined />,
            label: 'Payout',
            children: [
                { key: '/pip-Grid/payout-request', label: <Link to={'/pip-Grid/payout-request'}>Payout Request</Link> },
                { key: '/pip-Grid/payout-history', label: <Link to={'/pip-Grid/payout-history'}>Payout History</Link> },
            ],
        },
        { key: '/pip-Grid/setting', icon: <SettingOutlined />, label: <Link to={'/pip-Grid/setting'}>Setting</Link> },
        { key: '/pip-Grid/inquiry', icon: <ShareAltOutlined />, label: <Link to={'/pip-Grid/inquiry'}>Inquiry</Link> },
    ], []);

    const MakeMyProfitMenu = useMemo(() => [
        { key: '/make-my-profit/home', icon: <ProductOutlined />, label: <Link to={'/make-my-profit/home'}>Dashboard</Link> },
        { key: '/make-my-profit/users-list', icon: <UserOutlined />, label: <Link to={'/make-my-profit/users-list'}>Customer</Link> },
        { key: '/make-my-profit/leads', icon: <ShareAltOutlined />, label: <Link to={'/make-my-profit/leads'}>Leads</Link> },
        { key: '/make-my-profit/notes', icon: <BookOutlined />, label: <Link to={'/make-my-profit/notes'}>Notes</Link> },
        { key: '/make-my-profit/server', icon: <DatabaseOutlined />, label: <Link to={'/make-my-profit/server'}>Server</Link> },
        { key: '/make-my-profit/leads-inquiry', icon: <ShareAltOutlined />, label: <Link to={'/make-my-profit/leads-inquiry'}>Inquiry</Link> },
    ], []);

    // Helper to find which menu group the route belongs to
    const findMenuGroup = useCallback((route) => {
        const inMenu = (menu) => menu.some(item =>
            item.key === route ||
            (item.children && item.children.some(child => child.key === route))
        );
        if (inMenu(adminMenuItems)) return '1';
        if (inMenu(whiteLabelMenuItems)) return '2';
        if (inMenu(PipadminMenuItems)) return '3';
        if (inMenu(MakeMyProfitMenu)) return '4';
        return '1'; // default to admin
    }, [adminMenuItems, whiteLabelMenuItems, PipadminMenuItems, MakeMyProfitMenu]);

    // Memoized menu selection logic
    const menuItems = useMemo(() => {
        switch (headerMenu) {
            case '1': return adminMenuItems;
            case '2': return whiteLabelMenuItems;
            case '3': return PipadminMenuItems;
            case '4': return MakeMyProfitMenu;
            default: return adminMenuItems;
        }
    }, [headerMenu, adminMenuItems, whiteLabelMenuItems, PipadminMenuItems, MakeMyProfitMenu]);

    // Set currentActive to currentRoute directly
    useEffect(() => {
        setCurrentActive(currentRoute);
    }, [currentRoute]);

    // Automatically set headerMenu based on currentRoute
    useEffect(() => {
        setHeaderMenu(findMenuGroup(currentRoute));
    }, [currentRoute, findMenuGroup]);

    // Memoized fetchCounters
    const fetchCounters = useCallback(() => {
        apiService.get('/counter')
            .then(res => {
                setUserCount({
                    closeUser: res.closedUsers,
                    pendingUser: res.pendingUsers,
                    user: res.users,
                    settingReq: res.settingReq,
                    editReq: res.editReq,
                    wlList: res.whiteLabel,
                    wlPending: res.pendingWhiteLabel,
                    wlClosed: res.closedWhiteLabel,
                });
            })
            .catch(console.log);
    }, [apiService]);

    // WebSocket and initial counters
    useEffect(() => {
        webSocketService.onMessage('counterHit', fetchCounters);
        fetchCounters();
        // Cleanup
        return () => {
            webSocketService.offMessage && webSocketService.offMessage('counterHit', fetchCounters);
        };
    }, [user, fetchCounters]);

    // Memoized handlers
    const logoutHandle = useCallback(() => {
        LocalStorageService.removeItem("userToken");
        LocalStorageService.removeItem("user");
        setUserData(null);
        isLogin(false);
        navigate(getLoginRoute({...user, ...customer}));
    }, [setUserData, isLogin, navigate, user, customer]);

    const downloadDatabase = useCallback(() => {
        setLoading(true);
        apiService.get('/database/download')
            .then(res => {
                if (res) {
                    const dataStr = JSON.stringify(res, null, 2);
                    const blob = new Blob([dataStr], { type: "application/json" });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = "data.json";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            })
            .catch(console.log)
            .finally(() => setLoading(false));
    }, [apiService]);

    const menuClick = useCallback((val) => {
        switch (val?.key) {
            case "0":
                logoutHandle();
                break;
            case "1":
                downloadDatabase();
                break;
            default:
                break;
        }
    }, [logoutHandle, downloadDatabase]);

    // Memoized sidebar logo
    const sidebarLogo = useMemo(() => (
        <div className="demo-logo-vertical sidebar-logo" style={{ fontSize: 22, color: "#fff" }}>
            {collapsed ? <img src={logoSm} /> : <img src={logo} />}
        </div>
    ), [collapsed]);

    return (
        <Layout style={{ height: "100%" }}>
            <Sider
                theme='dark'
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={230}
                style={sidebarStyle}
                className='layout-sidebar'
            >
                {sidebarLogo}
                <Menu
                    mode="inline"
                    theme='dark'
                    selectedKeys={[currentRoute]}
                    items={menuItems}
                    defaultOpenKeys={['transaction', 'service-request', 'white-label', 'white-label-users', 'white-label-transaction', 'pip-users']}
                    style={{
                        background: "#131c2b",
                    }}
                />
            </Sider>
            <Layout style={{ marginLeft: collapsed ? 80 : 230, transition: 'margin-left 0.3s ease-in-out', marginTop: 64, }}>
                <Header
                    style={headerStyle(collapsed)}
                >
                    <Flex justify='space-between'>
                        <Space size={'large'}>
                            <Button
                                type="text"
                                icon={collapsed ? <MenuUnfoldOutlined style={{ color: "#fff" }} /> : <MenuFoldOutlined style={{ color: "#fff" }} />}
                                onClick={() => setCollapsed(!collapsed)}
                                style={{
                                    fontSize: '16px',
                                    width: 64,
                                    height: 64,
                                }}
                            />
                            {user?.role === 'ADMIN' && <Segmented
                                options={horizontalMenuItem}
                                value={headerMenu}
                                onChange={(e) => {
                                    setHeaderMenu(e)
                                    setCurrentActive('12')
                                    navigate(e == '1' ? '/home' : e === '2' ? '/white-label/home' : e === '3' ? '/pip-Grid/home' : '/make-my-profit/home')
                                }}
                            />}
                        </Space>
                        <Space size={20}>
                            <Notification />
                            <Dropdown
                                menu={{
                                    items: dropdownItems,
                                    onClick: menuClick
                                }}
                                trigger={['click']}

                            >
                                <a onClick={(e) => e.preventDefault()}>
                                    <Space style={{ color: "#fff" }} className="user-name">
                                        {user?.fullName}
                                        <DownOutlined />
                                    </Space>
                                </a>
                            </Dropdown>
                        </Space>
                    </Flex>

                </Header>
                <Content
                    style={contentStyle(borderRadiusLG)}
                >
                    {children}
                </Content>
            </Layout>
            {loading && <div className='loader-cust'>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>}
        </Layout>
    );
};
const mapStateToProps = ({ login, url }) => {
    const { user, customer } = login
    const { currentRoute } = url
    return { user, currentRoute, customer }
}
const mapDispatchToProps = {
    isLogin, setUserData
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);